import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmergencyIcon from '@mui/icons-material/Warning';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import MenuIcon from '@mui/icons-material/Menu';
import { ContactInfo } from './ContactInfo';
import './EmergencyContacts.css';
import { useTranslation } from 'react-i18next';

const WHATSAPP_NUMBER = '37126409932';
const APPOINTMENT_URL =
  'https://www.piearsta.lv/lv/iestazu-katalogs/zobarstniecibas-klinika-riga-dentique-1674';

interface Props {
  toggleMobileMenu: () => void;
}

const EmergencyContacts = ({ toggleMobileMenu }: Props) => {
  const { t } = useTranslation();

  const handleEmergency = () => {
    const message = encodeURIComponent(
      'Sveicināti!\nVēlos steidzami pieteikties uz vizīti, jo ir akūtas zobu sāpes.\nLūdzu, dodiet ziņu par tuvāko iespējamo vizītes laiku!\nPaldies!'
    );
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="emergency-container">
      <div className="emergency-left hide-contact-info">
        <ContactInfo />
      </div>

      <div className="emergency-right">
        <div className="emergency-buttons">
          <button
            className="emergency-btn emergency-btn--urgent"
            onClick={handleEmergency}
            aria-label={t('emergencyHeader.emergency')}
          >
            <EmergencyIcon fontSize="small" />
            <span className="btn-label">{t('emergencyHeader.emergency')}</span>
          </button>

          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}`}
            target="_blank"
            rel="noopener noreferrer"
            className="emergency-btn emergency-btn--whatsapp"
            aria-label="WhatsApp"
          >
            <WhatsAppIcon fontSize="small" />
            <span className="btn-label">{t('emergencyHeader.whatsapp')}</span>
          </a>

          <a
            href={APPOINTMENT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="emergency-btn emergency-btn--book"
            aria-label={t('emergencyHeader.eAppointment')}
          >
            <PersonAddAltIcon fontSize="small" />
            <span className="btn-label btn-label--desktop">
              {t('emergencyHeader.eAppointment')}
            </span>
            <span className="btn-label btn-label--mobile">
              {t('emergencyHeader.appointment')}
            </span>
          </a>
        </div>

        <button
          className="menu-toggle"
          onClick={toggleMobileMenu}
          aria-label="Open menu"
        >
          <MenuIcon fontSize="large" />
        </button>
      </div>
    </div>
  );
};

export default EmergencyContacts;
